<template lang="pug">
</template>

<script>
export default {
    name: 'LoginThirdParty',
    /**
     * @override
     */
    mounted() {
        this.$authService
            .authenticate365({
                grant_type: 'authorization_code',
                code: this.$route.query.code,
                redirect_url: 'https://app.getpostman.com/oauth2/callback'
            })
            .then(() => this.$usersService.getMe())
            .then(() => this.$router.push({ name: 'dashboard' }))
            .catch(err => {
                this.$toast.error(err);
            });
    }
};
</script>
